import React from 'react';
import './Resources.css';

function Resources() {
    return (
        <div className="resources">
            <div className="resources-card">
                <div className="container">
                    <div className="col-md-12 mx-auto my-4">
                        <div className="resource_text">
                            <h1>
                                <span>DM</span> Resources and Blog                             
                            </h1>
                            <p>DharManager provide valuable resources, articles and blog post related to HRM topics. Read about our different projects and challenges we’ve successfully tackled for clients which showcase our expertise and problem-solving abilities.</p>
                        </div>
                        <div className="col-md-4 mx-auto text-center">
                            <button id="more" className="btn resource_button">Read Articles</button>
                        </div>
                    </div>
                    {/* <div className="resource_box">
                        <div className="row">
                            <div className="col-md-3 mb-5">
                                <div className="box">
                                    <img src="/images/dhart/ebook.png" alt="image" />
                                    <h2>HR eBooks</h2>
                                </div>
                            </div>
                            <div className="col-md-3 mb-5">
                                <div className="box">
                                    <img src="/images/dhart/webinar.png" alt="image" />
                                    <h2>Webinars</h2>
                                </div>
                            </div>
                            <div className="col-md-3 mb-5">
                                <div className="box">
                                    <img src="/images/dhart/case_study.png" alt="image" />
                                    <h2>Case Studies</h2>
                                </div>
                            </div>
                            <div className="col-md-3 mb-5">
                                <div className="box">
                                    <img src="/images/dhart/blog.png" alt="image" />
                                    <h2>Blogs</h2>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    );
}

export default Resources;
